/* eslint-disable */
// @ts-nocheck

import { getFbPixelIdForSubdomain } from "../helpers/analyticsHelpers";

// Get the Facebook Pixel ID for the current subdomain
const FB_PIXEL_ID = getFbPixelIdForSubdomain();

// Only load the Facebook Pixel if we have a valid ID
if (FB_PIXEL_ID) {
  // Facebook Pixel base code
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

  // Initialize with the subdomain-specific pixel ID
  fbq("init", FB_PIXEL_ID);
  fbq("track", "PageView");

  console.log(`Facebook Pixel initialized with ID: ${FB_PIXEL_ID}`);
} else {
  console.log("No Facebook Pixel ID found for this subdomain. Pixel not loaded.");
}
